<div class="report row mx-md-0 px-md-0">
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Client ID:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ customer.customerId }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Client:</span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ customer.customerName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Phone No.:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ customer.customerPhone1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Installment Amount:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{
          itm.instalmentAmountX1 | number
          }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Due Date:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.instalmentDueDateX1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Instalment Number:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.instalmentNumberX1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start ">
        <span class="">Instalment Paid:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.instalmentPaidX1 | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Payment Date:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.instalmentPaymentDateX1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Payment Time:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.instalmentPaymentTimeX1}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Instalment Remaining:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.instalmentRemainingX1 | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Instalment Status:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.instalmentStatusX1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Interest Amount:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.interestAmountX1 | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Interest Paid:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.interestPaidX1 | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 col-xl-6 d-flex justify-content-start">
        <span class="">Interest Remaining:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.interestRemainingX1 | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Interest Reversed:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.interestReversedX1 | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Interest Written Off:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.interestWrittenOffX1 | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Penalty Amount:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.penaltyAmountX1 | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Penalty Paid:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.penaltyPaidX1 | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Penalty Remaining:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.penaltyRemainingX1 | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Principal Amount:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.principalAmountX1 | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Principal Paid:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.principalPaidX1 | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Principal Remaining:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.principalRemainingX1 | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Principal Reversed:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.principalReversedX1 | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Principal Written Off:</span>
      </div>
      <div class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.principalWrittenOffX1 | number}}
        </span>
      </div>
    </div>
  </div>
</div>
